import React from 'react'

import styled from '@emotion/styled'
import {
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  AlignItems,
  Color,
  Body1,
  Heading2,
} from '@gousto-internal/citrus-react'

import { IRAFOffer } from 'routes/Account/Referral/ReferralPresentation'

const InstructionsContainer = styled(Box)`
  display: flex;
  background: #333d47;
  border-radius: 8px;
  width: 100%;
  overflow: hidden;
  flex-wrap: wrap;
  padding: 20px;
  margin: 18px 0px 20px;

  @media (max-width: 886px) {
    border-radius: 0;
    flex-direction: column;
    padding: 16px;
  }
`

const InstructionItem = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  padding: 24px;
  border-right: 1px solid #5a6a7c;
  flex: 1;
  max-width: 33.33%;
  margin: 0 8px;
  background: #516272;
  border-radius: 16px;
  position: relative;

  @media (max-width: 886px) {
    max-width: 100%;
    width: 100%;
    margin: 18px 0;
    border-right: none;
    border-bottom: 1px solid #5a6a7c;

    &:last-child {
      border-bottom: none;
    }
  }
`

const StepNumber = styled.span`
  position: absolute;
  top: -16px;
  left: 10px;
  display: inline-block;
  background: #d0aa46;
  color: #333d47;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  text-align: center;
  line-height: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  z-index: 1;
`

const Container = styled(Box)`
  gap: 24px;
`

interface Props {
  rafOffer: IRAFOffer
}

export const RAFBoostInstructions = ({ rafOffer }: Props) => {
  const referrerCredit = rafOffer.get('creditFormatted') as string
  const firstBoxDiscount = rafOffer.get('firstBoxDiscountFormatted') as string
  const firstMonthDiscount = rafOffer.get('firstMonthDiscountFormatted') as string
  const secondBoxDiscount = rafOffer.get('secondBoxDiscountFormatted') as string | undefined
  const discountDuration = rafOffer.getIn(['discountDuration', 'formatted']) as string

  return (
    <Container>
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        justifyContent={JustifyContent.Center}
        alignItems={AlignItems.Center}
      >
        <Heading2 color={Color.White}>How it works</Heading2>
      </Box>
      <InstructionsContainer display={Display.Flex} justifyContent={JustifyContent.SpaceEvenly}>
        <InstructionItem>
          <StepNumber>1</StepNumber>
          <Body1 color={Color.White}>
            {secondBoxDiscount
              ? `Invite your friends to try Gousto. We’ll pop ${referrerCredit} in your account and your friends will get ${firstBoxDiscount} off their first box, ${secondBoxDiscount} off their second box and ${firstMonthDiscount} off all other boxes in their first ${discountDuration}.`
              : `Invite your friends to try Gousto. We’ll pop ${referrerCredit} in your account and your friends will get ${firstBoxDiscount} off their first box and ${firstMonthDiscount} off all other boxes in their first ${discountDuration}.`}
          </Body1>
        </InstructionItem>
        <InstructionItem>
          <StepNumber>2</StepNumber>
          <Body1 color={Color.White}>
            You can refer up to 20 friends every month. That’s £400 worth of Gousto credit to use on
            recipes and goodies from the Gousto market.
          </Body1>
        </InstructionItem>
        <InstructionItem>
          <StepNumber>3</StepNumber>
          <Body1 color={Color.White}>
            Your credit shows up once your friend’s first box is delivered. See full T&Cs{' '}
            <a
              style={{ color: '#A29EFF' }}
              href="https://cook.gousto.co.uk/raf-tcs/"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>
          </Body1>
        </InstructionItem>
      </InstructionsContainer>
    </Container>
  )
}
